var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2V12C3.75 12.7031 3.16406 13.25 2.5 13.25C1.79688 13.25 1.25 12.7031 1.25 12V2C1.25 1.33594 1.79688 0.75 2.5 0.75C3.16406 0.75 3.75 1.33594 3.75 2ZM2.5 18.25C1.91406 18.25 1.40625 17.9766 1.13281 17.4688C0.859375 17 0.859375 16.4141 1.13281 15.9062C1.40625 15.4375 1.91406 15.125 2.5 15.125C3.04688 15.125 3.55469 15.4375 3.82812 15.9062C4.10156 16.4141 4.10156 17 3.82812 17.4688C3.55469 17.9766 3.04688 18.25 2.5 18.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.8b6570fcea4de11dbefc0909ba7e4a9f.svg";
export { ForwardRef as ReactComponent };